import React, { useCallback, useMemo, useState } from 'react';
import FullScreenContainer from 'components/fullScreenContainer';
import ImgManage from 'assets/images/uninstall-sad-face-monochromatic.png';
import ImgSuccessful from 'assets/images/uninstall-heart-face-monochromatic.png';
import { Input } from 'antd';
import { sendUninstallResponse } from 'data/actions/plugin';
import { accountSelector, workspaceIdSelector, isAuthSelector } from 'data/selectors/user';
import { FULLSCREEN_BUTTONS } from 'constants/fullScreenButtons';

import { useSelector, useDispatch } from 'react-redux';

import { Radio, RadioGroup, Button } from 'components/common';

import { RadioStyle, Header, Text, ContentImg, LogoForm, SubmitForm, UninstallContainer } from './styles';

const ExtensionUninstallFeedback = () => {
  const [includeReason, setIncludeReason] = useState('');
  const [descriptionReason, setDescriptionReason] = useState('');
  const [status, setStatus] = useState(false);
  const dispatch = useDispatch();

  const { TextArea } = Input;
  const { _id: loggedUserId } = useSelector(accountSelector);

  const currentUserworkspaceId = useSelector(workspaceIdSelector);
  const isAuth = useSelector(isAuthSelector);

  const fallbackEmail = useMemo(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const data = params.get('data');
      if (data) return atob(data);
    } catch (e) {
      /* invalid base64 */
    }
    return localStorage.getItem('lastUserEmail') || null;
  }, []);

  const handleRedirectBack = useCallback(() => {
    const path = isAuth && currentUserworkspaceId ? `/${currentUserworkspaceId}/contacts/filter/all` : '/login';
    window.location.href = path;
  }, [isAuth, currentUserworkspaceId]);

  const handleSendReason = () => {
    const body = {
      message: descriptionReason,
      uninstallReason: includeReason,
    };
    if (loggedUserId) body.userId = loggedUserId;
    if (currentUserworkspaceId) body.workspaceId = currentUserworkspaceId;
    if (!loggedUserId && fallbackEmail) body.email = btoa(fallbackEmail);
    dispatch(sendUninstallResponse(body, { skipAuth: !isAuth }));
    setStatus(true);
  };

  const renderUninstallPage = () => {
    if (status) {
      return (
        <UninstallContainer style={{ flexDirection: 'column' }}>
          <LogoForm>
            <ContentImg
              src={ImgSuccessful}
              onLoad={(e) => {
                e.target.style.display = 'flex';
                e.target.style.marginLeft = '50px';
              }}
            />
          </LogoForm>
          <h2>Thank you for your feedback</h2>
          <p>Your message has been sent to our team. We will be glad to see you again!</p>
        </UninstallContainer>
      );
    }
    return (
      <UninstallContainer>
        <LogoForm>
          <ContentImg
            src={ImgManage}
            onLoad={(e) => {
              e.target.style.display = 'flex';
            }}
          />
          <Header> We are sorry to see you go... </Header>
          <Text> Before you go, please let us know how we can improve.</Text>
        </LogoForm>
        <SubmitForm>
          <Header>Why are you uninstalling GetProspect extension?</Header>
          <RadioGroup
            onChange={(e) => setIncludeReason(e.target.value)}
            value={includeReason}
            style={{ margin: '20px 20px 20px 0' }}
          >
            <Radio style={RadioStyle} value="The extension doesn’t work for me.">
              The extension doesn’t work for me.
            </Radio>
            <Radio style={RadioStyle} value="It’s too complicated to use.">
              It’s too complicated to use.
            </Radio>
            <Radio style={RadioStyle} value="Email discovery rate/accuracy is too low.">
              Email discovery rate/accuracy is too low.
            </Radio>
            <Radio style={RadioStyle} value="I finished the work I have to do.">
              I finished the work I have to do.
            </Radio>
            <Radio style={RadioStyle} value="Some features are missing.">
              Some features are missing.
            </Radio>
            <Radio style={RadioStyle} value="I switched to another tool.">
              I switched to another tool.
            </Radio>
            <Radio style={RadioStyle} value="Other">
              Other
            </Radio>
          </RadioGroup>
          <Text style={{ margin: '0 0 10px 0' }}>
            What can we do better? Your feedback goes straight to our team on Slack.{' '}
          </Text>
          <TextArea
            rows={4}
            placeholder="How can we improve the experience with the extension?"
            value={descriptionReason}
            size="small"
            onChange={(e) => {
              setDescriptionReason(e.target.value);
            }}
          />
          <Button
            data-form="true"
            type="primary"
            disabled={false}
            onClick={handleSendReason}
            style={{ marginTop: '10px', width: '190px' }}
          >
            Send
          </Button>
        </SubmitForm>
      </UninstallContainer>
    );
  };

  return (
    <FullScreenContainer redirectBack={handleRedirectBack} typeButton={FULLSCREEN_BUTTONS.BACK}>
      {renderUninstallPage()}
    </FullScreenContainer>
  );
};

export default ExtensionUninstallFeedback;
